import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
} from '@angular/core';
import { ContentItem } from './content-item.model';
import { AnalyticsService } from '../../@core/analytics.service';

@Component({
    selector: 'app-content-item',
    templateUrl: './content-item.component.html',
    styleUrls: ['./content-item.component.scss'],
})
export class ContentItemComponent implements OnChanges, OnInit {
    readonly measurement?: number = 1.23263888889;
    altImageOn = false;
    currentVisibleImage = '';
    currentWishlistIcon = '';

    @Input() item: ContentItem | any;

    @Input() scrollingType?: string;
    @Input() onChangeFire = false;

    @Output() processLink: EventEmitter<string> = new EventEmitter();

    botAgent = false;

    constructor(private analyticsService: AnalyticsService) {}

    process(link: string) {
        this.processLink.emit(link);
    }

    setHoverImage(value: any, replace: string) {
        switch (replace) {
            case 'content':
                {
                    this.currentVisibleImage = this.item?.altImage;
                    this.altImageOn = true;
                }
                break;
            case 'wishlist':
                {
                    if (!!this.item.button?.future) {
                        this.item.button.icon = this.item.button?.future?.image;
                    }
                }
                break;
        }
    }

    setInitialImage(value: any, replace: string) {
        switch (replace) {
            case 'content':
                {
                    this.currentVisibleImage = this.item?.image;
                    this.altImageOn = false;
                }
                break;
            case 'wishlist':
                {
                    this.item.button.icon = this.currentWishlistIcon;
                }
                break;
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        this.currentWishlistIcon = this.item.button?.icon;
        this.currentVisibleImage = this.item?.image;
    }

    ngOnInit() {
        this.botAgent = this.analyticsService.isBot(window.navigator.userAgent);
    }
}
